const lang = {
    'title': 'GoShare - Hop on! Enjoy e-scooter sharing service by Gogoro',
    'description': 'With GoShare, you can find, reserve and ride a Gogoro Smartscooter® any time you need it.',
};

export default lang;
